import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ActivityLog from './ActivityLog'
import {
    authUserInfo,
    isPageReachBottom,
    isSetItem,
    onErrorImageLoad
} from '../../../helpers/Util'
import { useParams } from 'react-router-dom'
import {
    fetchTimeline,
    toggleSetMembersSelection
} from '../../../redux_toolkit/Timeline/TimelineThunks'
import { useLoader } from '../../../redux_toolkit/Loader'
import Image from '../../../common/Image'
import { toast } from 'react-toastify'

const TimelineActivityLog = ({ toggleAddComment, setLoader }) => {
    const timelineStore = useSelector((store) => store.timeline)
    const dispatch = useDispatch()
    const myStateRef = useRef({})
    const params = useParams()
    const isLoading = useRef(false)
    const [productsOfSet, setProductsOfSet] = useState([])
    const [activeSetMemberInfo, setActiveSetMemberInfo] = useState(null)
    const scrollTimeoutRef = useRef(null)
    const extractAndOrganizeSetItem = () => {
        const listOfSetMembers = []
        const orderProducts = timelineStore?.selectedSetItem || []

        orderProducts.forEach((design) => {
            if (isSetItem(design)) {
                design?.setMemberList.forEach((member) => {
                    listOfSetMembers.push({
                        ...member,
                        rfqId: design?.rfqStatusInfoList[0]?.rfqId
                    })
                })
                listOfSetMembers.push({
                    id: design?.id,
                    name: 'handOver',
                    image: '/icons/order-hand-over.svg',
                    rfqId: design?.rfqStatusInfoList[0]?.rfqId
                })
            }
        })
        setProductsOfSet(listOfSetMembers)
    }
    useEffect(() => {
        const initialRfqId =
            timelineStore?.selectedDesignRFQIds?.length > 0
                ? timelineStore?.selectedDesignRFQIds[0]?.rfqId
                : null
        dispatch(
            fetchTimeline(
                generateTimeLineParams(
                    timelineStore?.selectedDesignList,
                    generateParams(),
                    generateSetMemberParam(),
                    initialRfqId
                ),
                false
            )
        )
    }, [timelineStore?.selectedDesignRFQIds])

    useEffect(() => {
        extractAndOrganizeSetItem()
    }, [timelineStore])

    useEffect(() => {
        setActiveSetMemberInfo(productsOfSet[0])
    }, [JSON.stringify(productsOfSet)])

    const setIsDataLoading = (data) => {
        isLoading.current = data
    }
    const generateSetMemberParam = () => {
        return timelineStore?.selectedSetItem?.length > 0 &&
            !timelineStore?.isSetParent
            ? `&setMemberId=${timelineStore?.selectedDesignList[0]}`
            : ''
    }
    const generateTimeLineParams = (
        selectedDesignList,
        params,
        paramOfSetMember = '',
        rfqId
    ) => {
        if (selectedDesignList?.length > 0) {
            params += `&rfqId=${rfqId}${paramOfSetMember}`
        }
        return params
    }

    const setMyState = (data) => {
        myStateRef.current = data
    }

    useEffect(() => {
        setMyState(timelineStore)
    }, [timelineStore])

    const handleScroll = () => {
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current)
        }

        scrollTimeoutRef.current = setTimeout(() => {
            if (isPageReachBottom() && !isLoading.current) {
                const {
                    totalElements,
                    currentPage,
                    totalPages,
                    selectedDesignList,
                    data,
                    rfqId,
                    isSetParent
                } = timelineStore

                if (
                    totalElements > 0 &&
                    totalElements !== data.length &&
                    currentPage < totalPages
                ) {
                    isLoading.current = true
                    let paramString
                    if (selectedDesignList?.length > 0) {
                        paramString = `${params.orderId}?page=${
                            currentPage + 1
                        }&size=15&rfqId=${rfqId}${
                            !isSetParent
                                ? `&setMemberId=${selectedDesignList[0]}`
                                : ''
                        }`
                    } else {
                        paramString = `${params.orderId}?page=${
                            currentPage + 1
                        }&size=15`
                    }
                    setLoader(true)
                    dispatch(fetchTimeline(paramString, true))
                        .then(() => {
                            isLoading.current = false
                        })
                        .finally(() => {
                            setLoader(false)
                        })
                }
            }
        }, 200)
    }

    useEffect(() => {
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current)
            }
        }
    }, [timelineStore])

    const renderTimeline = () => {
        if (timelineStore?.data?.length > 0) {
            return timelineStore?.data?.map((item, index) => {
                return (
                    <ActivityLog
                        key={`activity_log_${item.id}`}
                        index={index}
                        activity={item}
                        setLoader={setLoader}
                    />
                )
            })
        } else {
            return (
                <p className='no-activity-text'>
                    {' '}
                    No activity found for this style
                </p>
            )
        }
    }

    const generateParams = () => {
        return `${params.orderId}?page=0&size=15`
    }

    const toggleSetMembersTab = async (design) => {
        window.scrollTo(0, 0)
        setLoader(true)
        await dispatch(
            toggleSetMembersSelection(design, generateParams(), params.orderId)
        )
        setLoader(false)
    }

    const onToggleSetMembersTab = (design) => {
        setActiveSetMemberInfo(design)
        toggleSetMembersTab({
            id: design?.id,
            rfqId: design?.rfqId,
            isSetParent: design.name === 'handOver'
        })
    }

    const handleCommentClick = () => {
        if (!timelineStore.isAllStyleSelected) {
            toggleAddComment()
        }
    }

    const checkIsStatic = (image) => {
        if (image === '/icons/order-hand-over.svg') {
            return true
        }
        return false
    }

    return (
        <>
            <div className='one-third activity-logs'>
                <div className='top-write-comments'>
                    {productsOfSet.length > 0 && (
                        <div className='set-image-tab mb-4 ml-1'>
                            {productsOfSet.map((member) => (
                                <div
                                    key={member.id}
                                    onClick={() =>
                                        member?.id !==
                                            activeSetMemberInfo?.id &&
                                        onToggleSetMembersTab(member)
                                    }
                                >
                                    <Image
                                        src={member?.image}
                                        alt='product'
                                        className={`${
                                            member?.id ===
                                            activeSetMemberInfo?.id
                                                ? 'active'
                                                : ''
                                        }`}
                                        isStatic={checkIsStatic(member?.image)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    <div
                        className='comments-button cursor-pointer'
                        onClick={handleCommentClick}
                    >
                        <p className='regular-12 mb-0 flex items-center'>
                            <Image
                                src={
                                    authUserInfo()?.profilePicDocument
                                        ?.docUrl ||
                                    '/images/pro_pic_default.png'
                                }
                                onError={(e) =>
                                    onErrorImageLoad(
                                        e,
                                        authUserInfo()?.profilePicDocument
                                            ?.docUrl
                                    )
                                }
                                alt='profile'
                                className='profile-image'
                                isStatic={
                                    !authUserInfo()?.profilePicDocument?.docUrl
                                }
                            />
                            Write comment...
                        </p>
                        <Image
                            src='/icons/attachment.svg'
                            alt='attach'
                            className='attachment-icon'
                        />
                        {timelineStore.isAllStyleSelected && (
                            <div className='custom-tooltip-container'>
                                <p className='custom-tooltip'>
                                    Please select a style to add comment
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                <div className='activity-list custom-scroll'>
                    {renderTimeline()}
                </div>
            </div>
        </>
    )
}

export default TimelineActivityLog
